/* Copyright (c) 2017 Backpack Health LLC */

import { connect } from 'react-redux';
import * as _ from 'lodash';

import GroupJoinInstructions, {
  GroupJoinInstructionsProps,
} from '../../appUnauthorized/presenters/GroupJoinInstructions/GroupJoinInstructions';
import AuthorizedRouteNames from '../RouteNames';
import { selectors as groupSelectors, actions as groupActions } from '../../redux/ducks/group';
import { selectors as userSelectors, actions as userActions } from '../../redux/ducks/user';
import NavigationActions from '../redux/NavigationActions';
import { TrackEvent } from '../../../utilities/UserMetrics';

function mapStateToProps(state, routerProps): Partial<GroupJoinInstructionsProps> {
  const history = routerProps.history;
  const subdomain = _.get(routerProps, 'match.params.group', '').toLowerCase();
  const groupMetadata = groupSelectors.getGroupBySubdomain(state, subdomain);
  const userData = userSelectors.getUser(state).data;

  return {
    groupMetadata,
    subdomain,
    userData,
    activeGroupId: groupSelectors.getActiveGroupId(state),
    isRequestFailed: groupSelectors.getIsRequestGroupFailed(state),
    goBack: () => {
      NavigationActions.goBack(history, AuthorizedRouteNames.home());
    },
  };
}

function mapDispatchToProps(dispatch): Partial<GroupJoinInstructionsProps> {
  return {
    fetchGroup: (subdomain) => {
      dispatch(groupActions.requestGroupBySubdomain(subdomain));
    },
    setActiveGroup: (groupId, activeGroupId) => {
      if (groupId !== activeGroupId) {
        dispatch(groupActions.setActiveGroup(groupId));
      }
    },
    goToJoinGroup: (groupData, userData, lang) => {
      const { id, name } = groupData;
      TrackEvent.groupJoinInstructions.joinGroup(name);

      dispatch(userActions.submitUserUpdate(
        {
          ...userData,
          intent: {
            type: 'join_group',
            join_group: {
              group_id: id,
            },
          },
        },
        () => {},
      ));

      const langParam = lang ? `?lang=${lang}` : '';
      const url = `${window.location.origin}${AuthorizedRouteNames.intendedGroup()}${langParam}`;
      window.open(url);
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(GroupJoinInstructions);
